import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import dayjs from 'dayjs';
import 'dayjs/locale/ko';
import NoticePopup from './NoticePopupDialog';
import * as gnoticeStore from '../../../store/gnotice';

// 한국어 로케일 설정
dayjs.locale('ko');

const NoticePopupManager = () => {
  const [showNotices, setShowNotices] = useState([]);
  const sessionUser = useSelector((state) => state.session.sessionUser);

  // 공지사항 조회 및 필터링
  useEffect(() => {
    const fetchNotices = async () => {
      try {
        const response = await gnoticeStore.selectAll({popupYn: true});
        if (response) {
            console.log("fetchNotices => ", response);
            const today = dayjs();
            const filteredNotices = response.filter(notice => {
                console.log("notice => ", notice.endDate, today);
                // 1. 먼저 날짜 체크
                if (!dayjs(notice.endDate).isAfter(today)) {
                    return false;
                }

                // 2. 오늘하루 열지않기 체크
                const dontShowUntil = localStorage.getItem(`notice_${notice.id}_dont_show`);
                console.log("dontShowUntil => ", dontShowUntil);
                if (dontShowUntil) {
                  return false;
                }
                
                return true;
            });

            // 날짜순 정렬 (과거순)
            const sortedNotices = filteredNotices.sort((a, b) => 
                dayjs(a.startDate).diff(dayjs(b.startDate))
            );

            console.log("sortedNotices => ", sortedNotices);
            setShowNotices(sortedNotices);
        }
      } catch (error) {
        console.error('공지사항 조회 실패:', error);
      }
    };

    if (sessionUser) {
      fetchNotices();
    }
  }, [sessionUser]);

  // 공지사항 닫기 처리
  const handleNoticeClose = (noticeId) => {
    setShowNotices(prev => prev.filter(notice => notice.id !== noticeId));
  };

  return (
    <>
      {showNotices.map((notice, index) => {
  
        // 팝업 간격 설정 (패딩)
        const POPUP_PADDING = 20;
        // 팝업 너비
        const POPUP_WIDTH = 600;
        
        // 3개 이상일 때는 3개씩 그룹화
        const groupIndex = Math.floor(index / 3);
        const positionInGroup = index % 3;
        
        // 현재 그룹의 팝업 개수 계산 (최대 3개)
        const currentGroupCount = Math.min(showNotices.length, 3);
        
        // 현재 그룹의 총 너비 계산
        const currentGroupWidth = (currentGroupCount * POPUP_WIDTH) + ((currentGroupCount - 1) * POPUP_PADDING);
        
        // 시작 위치 계산 (중앙 기준)
        const startPosition = (window.innerWidth - currentGroupWidth) / 2;
        
        // 각 팝업의 위치 계산
        const popupLeft = startPosition + (positionInGroup * (POPUP_WIDTH + POPUP_PADDING));
        
        console.log("계산값 => ", {
            windowWidth: window.innerWidth,
            currentGroupCount,
            currentGroupWidth,
            startPosition,
            popupLeft,
            groupIndex,
            positionInGroup,
            totalNotices: showNotices.length
        });

        // 스타일 계산
        const popupStyle = {
            position: 'fixed',
            zIndex: 1000 + (showNotices.length - index),
            left: `${popupLeft}px`,
            top: '50%',
            transform: 'translateY(-50%)',
            isolation: 'isolate',
            pointerEvents: 'auto'
        };

        return (
            <NoticePopup
            key={notice.id}
            notice={notice}
            onClose={() => handleNoticeClose(notice.id)}
            style={popupStyle}
            aria-hidden={false}
            role="dialog"
            aria-modal="true"
            />
        );
        })}
    </>
  );
};

export default NoticePopupManager;